import { useEffect } from "react"
import Aos from "../aos/aos.js"
const ServiceCard = ({ icon, title, text, aos}) => {
    useEffect(() => {
        Aos(1000)
    })
    return (
        <div data-aos={aos} className="w-[300px] h-[300px] bg-black/20 hover:scale-110 transition-all delay-300 duration-500  rounded-lg shadow-md shadow-yellow-300 py-4 px-2 flex flex-col justify-center items-center space-y-4">
            <div className="flex space-x-4 items-center w-full">
                <div className="">
                <div className="bg-white w-12 h-12 rounded-full flex items-center justify-center text-yellow-500">
                    {icon}
                </div>
                </div>
                <div className="text-xl text-white font-extrabold font-mono text-center">{title}</div>
            </div>
            <div className="text-white text-xl text-justify">{text}</div>
        </div>
    );
}

export default ServiceCard;